export default {
  nav: {
    dashboard: "Control Panel",
    analytics: "Dashboard",
    catalog: "Catalogue",
    changes: "Events",
    history: "History",
    trends: "Price trends",
    prices: "Price Comparison",
    alerts: "Email alerts",
    intelligence: "Intelligence",
    radar: "Regulatory Radar",
    calendar: "Calendar",
    reports: "Reports",
    configuration: "Configuration",
    products: "My Products",
    competitors: "Competitors",
    sources: "Sources",
    severity: "Severity",
    administration: "Administration",
    users: "Users",
    auditLog: "Activity",
    profile: "My Profile",
    notifications: "Alerts",
    tagline: "Smart monitoring of the pharmaceutical market",
    goToDashboard: "Go to Dashboard",
    closeMenu: "Close menu",
    availableInPlan: "Available on the {plan} plan",
    versionHistory: "View version history",
  },
};
